import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { get } from "lodash";
import { faCommentSms, faClockRotateLeft } from "@fortawesome/pro-regular-svg-icons";
import { ComposerShell } from "@/components/composer-modal";
import { SegmentedTabs } from "@/components/segmented-tabs";
import { showSuccessToast, showErrorToast } from "@/components/toast";
import { useEmrContext } from "@/hooks/emr-context";
import { usePatientDetails } from "@/hooks/patient";
import { usePatientMessages, useSmsTemplates, useOptOutStatus, useRetrySms } from "@/hooks/sms";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { SmsComposeTab } from "./sms-compose-tab";
import { SmsHistoryTab } from "./sms-history-tab";
/** SMS composer: Compose (send a templated text) and History (status + retry) tabs. */
export function SmsComposerBody(_ref) {
  var _patientDetails$data, _patientDetails$data2, _messagesQuery$data, _optOutQuery$data;
  var composer = _ref.composer;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useEmrContext = useEmrContext(),
    patientUid = _useEmrContext.patientUid,
    workspaceId = _useEmrContext.workspaceId,
    patientFirstName = _useEmrContext.patientFirstName,
    patientNumber = _useEmrContext.patientNumber;
  var _useState = useState("compose"),
    tab = _useState[0],
    setTab = _useState[1];
  useEffect(function () {
    trackEvent(ANALYTICS_EVENTS.SMS_PANEL_OPENED, {
      composerId: composer.id
    });
  }, [composer.id]);
  var patientDetails = usePatientDetails(workspaceId, patientUid, {
    enabled: false
  });
  var firstName = ((_patientDetails$data = patientDetails.data) === null || _patientDetails$data === void 0 || (_patientDetails$data = _patientDetails$data.basic_info) === null || _patientDetails$data === void 0 || (_patientDetails$data = _patientDetails$data.first_name) === null || _patientDetails$data === void 0 ? void 0 : _patientDetails$data.trim()) || patientFirstName;
  var numberOnFile = ((_patientDetails$data2 = patientDetails.data) === null || _patientDetails$data2 === void 0 || (_patientDetails$data2 = _patientDetails$data2.contact) === null || _patientDetails$data2 === void 0 ? void 0 : _patientDetails$data2.phone) || patientNumber || undefined;
  var messagesQuery = usePatientMessages(patientUid);
  var templatesQuery = useSmsTemplates(workspaceId);
  var optOutQuery = useOptOutStatus(patientUid);
  var retrySms = useRetrySms(patientUid);
  var messages = (_messagesQuery$data = messagesQuery.data) !== null && _messagesQuery$data !== void 0 ? _messagesQuery$data : [];
  var templates = useMemo(function () {
    var _templatesQuery$data;
    return (_templatesQuery$data = templatesQuery.data) !== null && _templatesQuery$data !== void 0 ? _templatesQuery$data : [];
  }, [templatesQuery.data]);
  var templateNameById = useMemo(function () {
    return templates.reduce(function (acc, template) {
      acc[template.id] = template.name;
      return acc;
    }, {});
  }, [templates]);
  var onRetry = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(messageId) {
      var detail, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            trackEvent(ANALYTICS_EVENTS.SMS_RETRY, {
              messageId: messageId
            });
            _context.p = 1;
            _context.n = 2;
            return retrySms.mutateAsync(messageId);
          case 2:
            showSuccessToast(t("sms.toast.requeued", {
              defaultValue: "SMS re-queued"
            }));
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            detail = get(_t, ["response", "data", "detail"], "");
            showErrorToast(detail || t("sms.toast.retry_failed", {
              defaultValue: "Could not retry. Please try again."
            }));
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function onRetry(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var changeTab = function changeTab(next) {
    setTab(next);
    trackEvent(next === "compose" ? ANALYTICS_EVENTS.SMS_TAB_COMPOSE : ANALYTICS_EVENTS.SMS_TAB_HISTORY, {
      composerId: composer.id
    });
  };
  return /*#__PURE__*/React.createElement(ComposerShell, {
    composerId: composer.id,
    title: t("sms.panel.title", {
      defaultValue: "Patient SMS"
    }),
    subtitle: t("sms.panel.subtitle", {
      defaultValue: "Send an identity-verified text and track its status"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 pt-1"
  }, /*#__PURE__*/React.createElement(SegmentedTabs, {
    testIdPrefix: "sms-tab",
    ariaLabel: t("sms.panel.tabs_label", {
      defaultValue: "SMS tabs"
    }),
    activeId: tab,
    onChange: changeTab,
    items: [{
      id: "compose",
      label: t("sms.tab.compose", {
        defaultValue: "Compose"
      }),
      icon: faCommentSms
    }, {
      id: "history",
      label: "".concat(t("sms.tab.history", {
        defaultValue: "History"
      }), " (").concat(messages.length, ")"),
      icon: faClockRotateLeft
    }]
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, tab === "compose" ? /*#__PURE__*/React.createElement(SmsComposeTab, {
    patientUid: patientUid,
    firstName: firstName,
    numberOnFile: numberOnFile,
    optedOut: (_optOutQuery$data = optOutQuery.data) !== null && _optOutQuery$data !== void 0 ? _optOutQuery$data : false,
    templates: templates,
    isLoadingTemplates: templatesQuery.isLoading,
    onSent: function onSent() {
      messagesQuery.refetch();
      changeTab("history");
    }
  }) : /*#__PURE__*/React.createElement(SmsHistoryTab, {
    messages: messages,
    isLoading: messagesQuery.isLoading,
    templateNameById: templateNameById,
    onRetry: onRetry,
    retryingId: retrySms.isLoading ? retrySms.variables : null
  }))));
}